import {whitelabelling as Whitelabelling} from 'whitelabelling';
import {AlgorithmUser} from 'model/algorithmUser';
import {AlgorithmUsers as AlgorithmUserCollection} from '../collection/algorithmUsers';

const BATCH_LOAD = 5;
const NEXT_EXPERT_INDEX_SKIP_POINT = 2;

export const MatchingController = [
    '$scope', '$timeout', '$q', '$location', 'RegistrationService',
    function($scope, $timeout, $q, $location, RegistrationService) {
        var MINIMUM_WAIT_TIME = 3000;

        // this is going to track which expert we're on
        var nextExpertIndex = 0;

        $scope.whitelabelling = Whitelabelling;

        // CLASS_HACK :: this is hacky and should be institutionalized better
        $('#page-content-inner').removeClass('book-step').addClass('matching-step');

        $scope.showLoadingCircle = true;
        $scope.showResults = false;
        $scope.results = new AlgorithmUserCollection();

        // these represent the experts we'll render to the page at a given
        $scope.currentExpert = null;
        $scope.nextExpert = null;
        $scope.previousExpert = null;

        var fetchParams = {data: {page: 1, count: BATCH_LOAD}};

        RegistrationService.getRegistrationData().then(function(data) {
            $scope.$emit('controllerLoaded', true);
            $scope.registrationData = data;

            // make sure we only get experts that can perform the desired consult types
            if ($scope.registrationData.DesiredConsultationTypes.length) {
                fetchParams.data.types = $scope.registrationData.DesiredConsultationTypes.pluck('id');
            }

            // if we're returning to the matching step, we'll have a lastViewedExpertIndex saved
            if ($scope.registrationData.get('lastViewedExpertIndex')) {
                // we want to navigate start off on our last viewed expert
                nextExpertIndex = $scope.registrationData.get('lastViewedExpertIndex');

                // our first request we need to get as many experts as we originally had to ensure our
                // lastViewedExpert is there
                fetchParams.data.count = nextExpertIndex + BATCH_LOAD;

                // don't wait any longer than we have to
                MINIMUM_WAIT_TIME = 0;
            }

            // set up our minimum wait time promise
            var deferred = $q.defer();
            $timeout(function() {
                deferred.resolve(true);
            }, MINIMUM_WAIT_TIME);

            var firstRound = new AlgorithmUserCollection();
            $q.all([
                deferred.promise,
                firstRound.fetch(fetchParams),
            ]).then(function(d) {
                // put the batch load back to normal in case we messed with it above
                fetchParams.data.count = BATCH_LOAD;

                if (firstRound.length < 3) {
                    // We found no results. Let's abort and treat it like a skip
                    $location.path('/complete');
                    return;
                }

                // add our first round expert query to our list of experts
                $scope.results.add(firstRound.models);

                // this is a liiiiitle hacky. We're leveraging the fact that backbone's .fetch promises the jqxhr
                // response and we're using that to also grab the current user's Algo profile. It's basically giving us
                // 2 pieces of data in one call (the list of matching expert profiles AND the consumer's profile)
                $scope.consumer = new AlgorithmUser(d[1].data.Consumer, {parse: true});

                // set up the nextExpert
                $scope.nextExpert = $scope.results.at(nextExpertIndex);

                // if we returned to the page on an expert passed the first one,
                // we need to make sure our previousExpert gets set properly
                if (nextExpertIndex > 0) {
                    $scope.currentExpert = $scope.results.at(nextExpertIndex - 1);

                    if (nextExpertIndex > 1) {
                        $scope.previousExpert = $scope.results.at(nextExpertIndex - 2);
                    }
                }

                // navigate to the next expert
                $scope.goToNextExpert();

                $timeout(function() {
                    $scope.showResults = true;
                }, 500);

                $timeout(function() {
                    $scope.showLoadingCircle = false;
                }, 1000);
            });
        });

        $scope.goToNextExpert = function() {
            if (!$scope.nextExpert) {
                return;
            }
            setChanging(1);
            $scope.previousExpert = $scope.currentExpert;
            $scope.currentExpert = $scope.nextExpert;

            nextExpertIndex++;
            if (nextExpertIndex >= $scope.results.length) {
                // set nextExpert to null
                $scope.nextExpert = null;

                var nextBatch = new AlgorithmUserCollection();
                fetchParams.data.page += 1;
                $q.when(nextBatch.fetch(fetchParams)).then(function() {
                    $scope.results.add(nextBatch.models);

                    /*
                        we need to check that it hasn't been set since. Consider the following use case:
                        1) Go to next expert
                        2) Fire request for more experts (preventing navigating forward for a moment)
                        3) Go to previous expert
                        4) Server responds with more experts ...
                        Without this check, step 4 would overwrite nextExpert which now has a valid value and whatever
                        expert it was pointing to would now be erroneously removed from the flow
                     */
                    if (!$scope.nextExpert) {
                        $scope.nextExpert = $scope.results.at(nextExpertIndex);
                    }
                });
            } else {
                $scope.nextExpert = $scope.results.at(nextExpertIndex);
            }

            if (nextExpertIndex > NEXT_EXPERT_INDEX_SKIP_POINT) {
                $scope.canSkip = true;
            }
        };

        $scope.goToPreviousExpert = function() {
            if (!$scope.previousExpert) {
                return;
            }
            setChanging(-1);
            $scope.nextExpert = $scope.currentExpert;
            $scope.currentExpert = $scope.previousExpert;
            nextExpertIndex--;
            if (nextExpertIndex <= 1) {
                $scope.previousExpert = null;
            } else {
                $scope.previousExpert = $scope.results.at(nextExpertIndex - 2);
            }

            if (nextExpertIndex <= NEXT_EXPERT_INDEX_SKIP_POINT) {
                $scope.canSkip = false;
            }
        };

        $scope.completeRegistration = function() {
            $location.path('/complete');
        };

        $scope.$on('triggerBooking', function() {
            // we persist the lastViewedExpertIndex so that if we return or decide to book another, we know where to
            // pick up
            $scope.registrationData.set('lastViewedExpertIndex', nextExpertIndex - 1);
            var requestedServices = $scope.registrationData.get('DesiredConsultationTypes').pluck('id');
            var commonServices = _.intersection($scope.currentExpert.get('verticalServiceids'), requestedServices);
            if (!commonServices.length) {
                // if somehow we don't have an intersection (there was a bug somewhere else),
                // we're just going to default to Career Conversation
                commonServices.push(3);
            }
            $location.path('/book/' + $scope.currentExpert.id + '/' + commonServices[0]);
        });

        function setChanging(val) {
            $scope.changing = val;
            $timeout(function() {
                $scope.changing = 0;
            }, 300); // how long it takes for the changing animation to complete
        }
    },
];
